import { staticImgBaseUrl } from "../config/apiEndpoints";

export const SavedAddressesListKeys = {
  mainTextKey: "customer_address_name",
  subTextKey: "formatted_address",
  itemIconKey: "customer_address_name",
  listTitle: "",
  editableIconClass: "hkfi-drag fs-24 color-slaty",
  listItemClass: "reusable-list-item-cart",
  latKey: "latitude",
  lngKey: "longitude",
};

export const SavedAddressesListKeysForMyAddress = {
  mainTextKey: "customer_address_name",
  subTextKey: "formatted_address",
  footerTextLeftKey: "recipient_name",
  footerTextRightKey: "recipient_number",
  isfooterTextAvailableKey: "order_for_someone_else",
  itemIconKey: "customer_address_name",
  listTitle: "",
  editableIconClass: "hkfi-drag fs-24 color-slaty",
  listItemClass: "saved-address-list-item",
  listContentWrapperClass: "saved-address-lst-wrpr",
  marginClass: "mb16 p12 br8 border",
  listItemBorderDisabled: true,
  latKey: "latitude",
  lngKey: "longitude",
};

export const SavedAddressesListKeysForMyAddressForCart = {
  mainTextKey: "customer_address_name",
  subTextKey: "formatted_address",
  footerTextLeftKey: "recipient_name",
  footerTextRightKey: "recipient_number",
  isfooterTextAvailableKey: "order_for_someone_else",
  itemIconKey: "customer_address_name",
  listTitle: "",
  editableIconClass: "hkfi-drag fs-24 color-slaty rotate90clockwise",
  listItemClass: "saved-address-list-item",
  listContentWrapperClass: "saved-address-lst-wrpr",
  marginClass: "mb16 p12 br8 border",
  listItemBorderDisabled: true,
  latKey: "latitude",
  lngKey: "longitude",
};

export const SavedAddressesListKeysForMannualLocation = {
  mainTextKey: "customer_address_name",
  subTextKey: "formatted_address",
  itemIconKey: "customer_address_name",
  listTitle: "Saved Addresses",
  listTitleClass: "bold fs-14 mb16 list-label disp-col-inline jcsb",
  className: "recent-searches",
  titleRightButton: "+ Add New Address",
  titleRightButtonClass: "color-tertiary fs-12 lh16 bold",
  listItemBorderDisabled: true,
  editableIconClass: "hkfi-drag fs-24 color-slaty",
  listItemClass: "saved-address-list-item",
  viewMoreEnableLimit: 3,
  listContentWrapperClass: "saved-address-lst-wrpr",
  latKey: "latitude",
  lngKey: "longitude",
};

export const SearchPredictionsListKeys = {
  mainTextKey: "structuredFormatting.mainText",
  subTextKey: "structuredFormatting.secondaryText",
  commanItemIconClass: "hkfi-location-line fs-22 color-slaty pt8",
  listTitle: "",
  listClassName: "search_lst_new",
  listItemClass: "reusable-list-item align-items-start",
};

export const RecentSearchListLength = 4;

export const RecentSearchListKeys = {
  mainTextKey: "structuredFormatting.mainText",
  subTextKey: "structuredFormatting.secondaryText",
  commanItemIconClass: "hkfi-recent fs-24 color-grey-light",
  listTitle: "Recent Searches",
  listTitleClass: "bold fs-14 mb3 list-label disp-col-inline jcsb",
  className: "recent-searches",
  titleRightButton: "Clear",
  titleRightButtonClass: "color-tertiary fs-12 lh16 bold",
  listItemBorderDisabled: true,
};

export const ModifiedAddressIcons = {
  Home: {
    icon: "hkfi-home-line",
  },
  Office: {
    icon: "hkfi-office-v2",
  },
  Other: {
    icon: "hkfi-location-line",
  },
};

export const FetchLocationKeys = {
  FETCHING_YOUR_LOCATION_TEXT: "Fetching your location ...",
  NO_LOCATION_TEXT: "No Location",
  DELIVERING_TO_TEXT: "Delivering to",
  EXACT_LOCATION_REQUIRED_TEXT: "Exact Location Required!",
};

export const LocationPageStaticKeys = {
  allowCtaBgColor: "#FFECED",
  allowCtaColor: "#EF414B",
  allowCtaText: "Allow Access",
  currentLocationLogo: staticImgBaseUrl + "/images/global/location-tick.png",
  giveLocationTitle: "Give us your exact location",
  gradientEndColor: "#F4E0C5",
  gradientStartColor: "#F3C2D1",
  useCurrentLocationTitle: "Use current location",
  noSavedAddressDetails: {
    iconImageURL: staticImgBaseUrl + "/images/global/no-saved-address-img.png",
    headingText: "No saved addresses for us to reach you :(",
    ctaText: "+ Add New Address",
    guestUserHeadingText: "Login to add or fetch saved addresses!",
    guestUserCtaText: "+ Login To Add Address",
  },
  deleteAddressPopupTexts: {
    deleteText: "Yes, Delete!",
    cancelText: "No, Cancel",
    headingText: "Are you sure you want to delete ",
  },
  searchLocationDetails: {
    locateOnMapText: "Locate On Map",
    cannotFindText: "Cannot find what you were searching for?",
    trySearchingText: "Try searching directly on the map!",
  },
  invalidSearchResultsDetails: {
    noResultsText:
      "Cannot find what you were searching for? Try searching directly on the map!",
    locationIcon:
      "https://hongs-dev0.hongskitchen.in/hongs-dev0-olo-api/contents/home-cms/nO9qtkQulLPhRA4NGfKXFwqqf9qkC52YSXjH3m0P.png",
    ctaText: "Locate On Map",
    noLocationsTitle: "Oops, Location not found!",
    noLocationsSubtitle:
      "Please check the spelling, try entering another area or location or search directly on the map!",
    noLocationImage: staticImgBaseUrl + "/images/global/invalid-search-img.png",
    ctaIcon: staticImgBaseUrl + "/images/global/map-icon.png",
  },
  myAddressDetails: {
    titleText: "My Addresses",
    addNewAddressText: "Add New Address",
    confirmAddressText: "Confirm Address",
    selectSavedAddressText: "Select a Saved Address",
  },
  searchText: "Search for a building, area or street name",
};

export const StoreUnavailabilityKeys = {
  notAtAllServicableTitle: "Uh-oh, we’re not quite there yet!",
  notAtAllServicableSubtitle:
    "Sorry, We’re not in your area yet. Try changing the location to order for yourself or someone else.	",
  notAtAllServicableBtnTitle: "Change Location",
  notAtAllServicableBgImage:
    "https://hongs-dev0.hongskitchen.in/hongs-dev0-olo-api/contents/home-cms/cCIKA2pir4eAUsUb3Ekq8Kito6GSFgRmhiauUKMP.png",
  notAtAllServicableBgLottieUrl:
    "https://hongs-dev0.hongskitchen.in/hongs-dev0-olo-api/contents/home-cms/ps0J68H3miu84cWgNG5tRp9mPjmXmKCgTafM3pxN.txt",
  nonServicableAreaTitle: "	Oops! Delivery Isn’t Available Here!",
  nonServicableAreaSubtitle:
    "Looks like online ordering isn’t available at your location yet. The nearest store is 8km away!",
  nonServicableAreaBtnTitle: "Change Location",
  nonServicableAreaBgImage:
    "	https://hongs-dev0.hongskitchen.in/hongs-dev0-olo-api/contents/home-cms/XWAGjBiQYgUGF2TCVz3yTE0axRYEd9sdEEpywnKw.png",
  nonServicableAreaLottieUrl:
    "https://hongs-dev0.hongskitchen.in/hongs-dev0-olo-api/contents/home-cms/hKP4OyTKbSuw1M8hdrHOHAq3q5Akttqgp4E0ITyq.txt",
  serviceOffTitle: "	Service Paused, but We’ll Be Back Soon!",
  serviceOffSubtitle:
    "Looks like delivery isn’t available right now, don’t worry. We’ll notify you the moment we’re back!",
  serviceOffBtnTitle: "Notify Me",
  serviceOffBgImage:
    "https://hongs-dev0.hongskitchen.in/hongs-dev0-olo-api/contents/home-cms/XWAGjBiQYgUGF2TCVz3yTE0axRYEd9sdEEpywnKw.png",
  serviceOffLottieUrl:
    "https://hongs-dev0.hongskitchen.in/hongs-dev0-olo-api/contents/home-cms/lh8FNu1zJvCPSA3ruEXIrEDDa7clsBCSx4s5GUTU.txt",
  nearbyStoreDividerLabel: "OR",
  nearestStoreSectionTitle: "Choose Takeaway/ Dine-In instead",
  nearbyStoreDividerRightImage:
    "https://hongs-dev0.hongskitchen.in/hongs-dev0-olo-api/contents/home-cms/OfUxEp2IsT2N087gqFR4um1oikFq6MmAc5RaNPjj.png",
  nearbyStoreDividerLeftImage:
    "https://hongs-dev0.hongskitchen.in/hongs-dev0-olo-api/contents/home-cms/UEaYw7P3rhpNPeIKzDCuLc0q1faEUs0GzEJwOyE7.png",
};

export const NewLocationPopupPermissionTextData = {
  primaryCTAText: "Enable Device Location",
  showLastSelectedAddress: "false",
};
